import React, { useEffect, useRef, useState } from "react";
import { Button } from "antd";
import "antd/es/button/style/css";
import styles from "./index.module.css";
import { UserInfoType } from "@meitu/xdesign-widgets/dist/types/userInfo";
import pptAiIcon from "@/assets/images/ppt-ai.png";
import Image from "next/image";
import { fetchRecordList } from "@/services/workbench";
import { Material } from "@/services/workbench/types";
import { thumbnail } from "@/utils";

const HEIGHT = 140;

interface RecordProps {
  userInfo?: UserInfoType;
  onRecordClick?: (item: Material) => void;
  col: number;
  totalWidth: number;
  gap: number;
  width: number;
}

const Record = (props: RecordProps) => {
  const { onRecordClick, col, totalWidth, gap, width } = props;
  const cursor = useRef("");
  const [list, setList] = useState<Material[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const loadRef = useRef<HTMLDivElement>(null);
  const hasMoreRef = useRef(true);
  const isIntRef = useRef(true);
  const [show, setShow] = useState(true);
  const count = useRef("20");
  const [loading, setLoading] = useState(false);
  const [hasCursor, setHasCursor] = useState(false);

  const getList = async () => {
    try {
      setLoading(true);
      const res = await fetchRecordList({
        type: 2,
        cursor: cursor.current,
        count: count.current,
      });
      console.log("【作图记录】：", res.data.data);
      setHasMore(!!res.data.data?.cursor);
      cursor.current = res.data.data?.cursor || "";
      setHasCursor(!!cursor.current);
      hasMoreRef.current = !!res.data.data?.cursor;
      setList((oldList) => {
        return [...oldList, ...res.data.data?.materials];
      });
    } finally {
      setLoading(false);
    }
    // if (isIntRef.current) {
    //     isIntRef.current = false;
    //     loadMore();
    // }
  };

  useEffect(() => {
    if (list.length) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [list]);

  useEffect(() => {
    getList();
  }, []);

  return (
    <div
      className={styles.pptRecord}
      style={{
        width: totalWidth,
      }}
    >
      {/* <div className="ppt-record-title">历史记录</div> */}
      {list.length ? (
        <div className={styles.pptRecordList}>
          {list.map((item, i) => {
            return (
              <div key={item.id} onClick={() => onRecordClick?.(item)}>
                <div
                  className={styles.pptRecordListItem}
                  style={{
                    width: width,
                    height: HEIGHT,
                    marginRight: (i + 1) % col === 0 ? 0 : gap,
                    // 第一行的 marginTop 为0，其他为24
                    marginTop: i < col ? 0 : 24,
                  }}
                >
                  {item.poster_type === 2 && (
                    <Image
                      width={35}
                      height={16}
                      src={pptAiIcon}
                      className={styles.pptRecordListItemIcon}
                      alt=""
                    />
                  )}
                  <div className={styles.pptRecordListItemTag}>
                    {`PPT ${item.canvas_pages}页`}
                  </div>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    className={styles.pptRecordListItemPreview}
                    width={item.material?.meta?.preview?.width || 0}
                    height={item.material?.meta?.preview?.height || 0}
                    src={thumbnail(item.material?.meta?.preview?.url || "")}
                    alt=""
                  />
                </div>
                <div
                  className={styles.pptRecordListItemName}
                  style={{
                    width: width,
                  }}
                  title={`${item.name || "未命名的设计.PPT"}`}
                >
                  {item.name || "未命名的设计.PPT"}
                </div>
              </div>
            );
          })}
        </div>
      ) : null}
      {!hasMore && (
        <div ref={loadRef} className={styles.pptRecordLoad}>
          没有更多了~
        </div>
      )}
      {hasMore && list.length && (
        <div className={styles.pptRecordLoadMore}>
          <Button onClick={getList}>加载更多</Button>
        </div>
      )}
    </div>
  );
};

export default React.memo(Record);
